import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { useMemo } from 'react';
import { AmountBadge } from '../../../../AmountBadge';

import styles from './styles/list_item.module.scss';

export const ListItem = ({ item }) => {
  const formattedDate = useMemo(
    () => dayjs(item.created_at).locale('ru').format('D MMMM YYYY'),
    [item],
  );

  const formattedCount = useMemo(
    () => `${item.count > 0 ? '+' : ''}${item.count}`,
    [item],
  );

  return (
    <div className={styles.list_item}>
      <p className={styles.list_item__header}>
        <AmountBadge
          amount={formattedCount}
          type={item.operation_type}
          currency="₽"
        />

        <span className={styles.list_item__header_name}>{item.title}</span>

        <span className={styles.list_item__header_date}>{formattedDate}</span>
      </p>

      {item.comment && item.comment !== '' ? (
        <p className={styles.list_item__comment}>{item.comment}</p>
      ) : null}
    </div>
  );
};
